module.exports = "//static.hsappstatic.net/LoginUI/static-1.15098/img/circle_desktop.svg"